module.exports = __webpack_public_path__ + "static/img/akum_800_120.4fdba02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_120.svg
// module id = AKv8
// module chunks = 1